import { HIDE_TEMPLATE_COUNT_DISPLAY_SPEC } from '@utils/constants';
import { useExperiments } from '@wix/fe-essentials-standalone';

const useHideTemplateCountDisplay = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isHidden = experiments.enabled(HIDE_TEMPLATE_COUNT_DISPLAY_SPEC);

  return { isHidden };
};

export default useHideTemplateCountDisplay;

